import { Button, Stack } from "@mui/material";
import SavedCardItem from "./SavedCardItem";
import { SavedPaymentMethod } from "@/redux";

interface Props {
    cards: SavedPaymentMethod[];
    selectedCardId?: string | null;
    onSelectCard: (id: string) => void;
    onDeleteCard: (id: string) => void;
    addAnotherCard: () => void;
}

export default function SavedCardsList({
    cards,
    selectedCardId,
    onSelectCard,
    onDeleteCard,
    addAnotherCard
}: Props) {
    return (
        <Stack spacing={2}>
            {cards.map(card => (
                <SavedCardItem
                    key={card.id}
                    card={card}
                    isSelected={card.id === selectedCardId}
                    onSelect={() =>
                        onSelectCard(card.id)
                    }
                    onDelete={() =>
                        onDeleteCard(card.id)
                    }
                />
            ))}
            <Button
                variant="outlined"
                fullWidth
                onClick={addAnotherCard}
            >
                Add Another Card
            </Button>
        </Stack>
    );
}